import { initializeApp } from "firebase/app";
import { getMessaging } from "firebase/messaging";
import { getDatabase, ref, get } from "firebase/database";



const firebaseConfig = {
  apiKey: "AIzaSyByGOBnW38R6MjlbGe1MA6DjMGTuGoVvsc",
  authDomain: "billtracecms-8401b.firebaseapp.com",
  projectId: "billtracecms-8401b",
  storageBucket: "billtracecms-8401b.appspot.com",
  messagingSenderId: "510184327918",
  appId: "1:510184327918:web:606ae1cdc1527f3ae6c1ff",
  measurementId: "G-XHBL8V7GJD"
};

// const firebaseConfig = {
//     apiKey: "AIzaSyB-KWok6Vkk56rjVyLgosWDrLagwfoA8BE",
//     authDomain: "push-notification-c037d.firebaseapp.com",
//     projectId: "push-notification-c037d",
//     storageBucket: "push-notification-c037d.appspot.com",
//     messagingSenderId: "501866431327",
//     appId: "1:501866431327:web:dfad5184d0fad606e0acea",
//     measurementId: "G-189RXGXGV7"
//   };




  export const app = initializeApp(firebaseConfig);
  export const messaging = getMessaging(app);
  export const database = getDatabase(app); 
  export {  ref, get };